import { generateAlternateLink } from './generateAlternateLink'
import { clearTrailingSlash } from './clearTrailingSlash'

export const generateAlternateLinksList = () => {
  const {
    applicationUrl,
    applicationUrlTj,
    applicationUrlUz,
    applicationUrlKz,
    applicationUrlKg,
    applicationUrlMd,
    applicationUrlBy,
    applicationUrlGe,
    applicationUrlAm,
  } = useRuntimeConfig().public
  const { pathname } = useRequestURL()

  const targetPathName = pathname === '/' ? '' : pathname

  return [
    generateAlternateLink(`${clearTrailingSlash(applicationUrl)}${targetPathName}`, 'ru-RU'),
    generateAlternateLink(`${clearTrailingSlash(applicationUrlKz)}${targetPathName}`, 'ru-KZ'),
    generateAlternateLink(`${clearTrailingSlash(applicationUrlBy)}${targetPathName}`, 'ru-BY'),
    generateAlternateLink(`${clearTrailingSlash(applicationUrlUz)}${targetPathName}`, 'ru-UZ'),
    generateAlternateLink(`${clearTrailingSlash(applicationUrlTj)}${targetPathName}`, 'ru-TJ'),
    generateAlternateLink(`${clearTrailingSlash(applicationUrlKg)}${targetPathName}`, 'ru-KG'),
    generateAlternateLink(`${clearTrailingSlash(applicationUrlMd)}${targetPathName}`, 'ru-MD'),
    generateAlternateLink(`${clearTrailingSlash(applicationUrlGe)}${targetPathName}`, 'ru-GE'),
    generateAlternateLink(`${clearTrailingSlash(applicationUrlAm)}${targetPathName}`, 'ru-AM'),
    generateAlternateLink(`${clearTrailingSlash(applicationUrl)}${targetPathName}`, 'x-default'),
  ]
}
